import getQueues from '../../api/getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import setQueueStatus from './setQueueStatus';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { serviceState } from '../../lib/state';

async function handleQueueSessionJoin(event: Telecom.QueueSessionJoinedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:session_join:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  setQueueStatus(queue, event);

  queue.sessions = [
    ...queue.sessions,
    {
      id: event.conversationId,
      position: event.joinedAtPosition,
      name: event.source.displayName ?? event.source.address,
      enteredAt: new Date(event.joinedAtTime),
    },
  ];
}

export default handleQueueSessionJoin;
